var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmpty(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "133px",
    height: "133px",
    viewBox: "0 0 133 133",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M0 66.5C0 29.7731 29.7731 0 66.5 0C103.227 0 133 29.7731 133 66.5C133 103.227 103.227 133 66.5 133C29.7731 133 0 103.227 0 66.5Z",
    id: "path_1"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip_1"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path_1"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group-11",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\xD3valo"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip_1)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path_1",
    fill: "none",
    stroke: "#9C9C9C",
    strokeWidth: 2,
    strokeDasharray: "4 4"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "IcoCerveza-Copy",
    transform: "translate(51 22)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.533 36.8337C28.9141 33.9935 27.4303 31.3333 27.2054 28.2226C27.2054 28.1323 26.0812 10.6399 25.9464 8.38566L27.0256 4.37323L27.0256 4.3281C27.5201 2.16394 25.7664 4.89576e-07 23.563 4.89576e-07L10.7022 4.89576e-07C8.49884 4.89576e-07 6.78994 2.16394 7.23961 4.3281L7.23961 4.37323L8.31879 8.38566L7.05979 28.2226C6.87996 31.3333 5.3511 34.0384 3.73223 36.8788C1.88851 40.1249 0 43.4611 0 47.6538L0 86.5612C0 90.6638 3.32756 94 7.41966 94L26.8008 94C30.8929 94 34.2204 90.6638 34.2204 86.5612L34.2204 47.6538C34.2652 43.4157 32.3767 40.0796 30.533 36.8337L30.533 36.8337ZM3.01277 47.3832L31.2524 47.3832L31.2524 82.6838L3.01277 82.6838C3.01277 82.6838 3.01277 47.4732 3.01277 47.3832L3.01277 47.3832ZM10.7022 2.93055L23.563 2.93055C23.9226 2.93055 24.1475 3.24623 24.1027 3.56168L23.2934 6.67243L10.9723 6.67243L10.1629 3.56168C10.0727 3.11084 10.4774 2.93055 10.7022 2.93055L10.7022 2.93055ZM6.65513 37.78L13.5351 37.78C15.4238 37.78 15.4686 34.8044 13.5351 34.8044L8.229 34.8044C9.17336 32.8659 9.89289 30.7469 10.0277 28.4024L11.1969 9.69257L23.0233 9.69257C24.1925 28.1319 24.1925 28.4024 24.1925 28.4024C24.3273 30.7469 25.0919 32.8657 25.9912 34.8044L20.7749 34.8044C18.8414 34.8044 18.8414 37.78 20.7749 37.78L27.5651 37.78C27.9697 38.276 30.1283 42.2884 30.7128 44.3623L3.46238 44.3623C4.09211 42.2884 6.07064 38.4563 6.65513 37.78L6.65513 37.78ZM26.8456 91.0247L7.46452 91.0247C5.03631 91.0247 3.01277 89.0411 3.01277 86.5614L3.01277 85.6598L31.2974 85.6598L31.2974 86.5614C31.2526 88.9959 29.2741 91.0247 26.8456 91.0247L26.8456 91.0247ZM17.1328 55.5883C11.9615 55.5883 7.73457 59.8261 7.73457 65.0108C7.73457 70.1954 11.9615 74.4333 17.1328 74.4333C22.304 74.4333 26.531 70.1954 26.531 65.0108C26.531 59.8261 22.304 55.5883 17.1328 55.5883L17.1328 55.5883ZM17.1328 71.4579C13.5804 71.4579 10.7025 68.5726 10.7025 65.011C10.7025 61.4494 13.5804 58.5641 17.1328 58.5641C20.6852 58.5641 23.5631 61.4494 23.5631 65.011C23.5631 68.5726 20.6852 71.4579 17.1328 71.4579L17.1328 71.4579Z",
    id: "Group",
    fill: "#C51A1B",
    fillRule: "evenodd",
    stroke: "none"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmpty);
export default __webpack_public_path__ + "static/media/empty.a616b409c68f0bfe00a7d4abcf08a9ea.svg";
export { ForwardRef as ReactComponent };